/**
 * @created : 2021/3/26
 * @author  : 王冲
 * @desc    : 邀请
 */

import { request } from "@weapp/utils";

//提交邀请
export const saveInvitees = (data: any) => {
  return request({
    url: `/api/basicserver/saves`,
    method: "post",
    data,
  });
};
//获取UUID
export const getUuid = () => {
  return request({
    url: `/api/basicserver/account/qureyKeyByUuid`,
    method: "post",
  });
};

//提交邀请
export const saveAppInvitees = (data: any) => {
  return request({
    url: `/api/app/basicserver/invite/saves`,
    method: "post",
    data,
  });
};
